export const environment = {
  production: true,
  Agent_Appeal_Url: '/Content/Appeal_Files/',
  iArRcmUrl : 'http://localhost:4002/',
  iDecisionTreeURL: 'https://www.gebbsiar.com/DecisionTree/Login.aspx',
  Encryptionkey:'IAR@gebbs_887887',
  version: '3.0',
  Allow_Origin: '172.18.4.129',
  releasedVersion: '7.0.0',
  clientInfo_clientIp: 'https://utl.ircmsuite.com/web-notification-api/api/ClientInfo/client-ip',
  passwordMinLength: 12,
  passwordMaxLength: 20,
  azureTicketApiUrl: 'https://utl.ircmsuite.com/AzureDevOpsWorkItemApi/api/',
    gebbsServiceDesk: 'https://utl.ircmsuite.com/Gebbs-Service-Desk/',
  // QA
  // FileApiUrl: "http://172.18.4.176/iARWebApi",
  // ApiUrl: "http://172.18.4.176/iARWebApi",
  // linkUsed: '172.18.4.176',

  // UAT
  FileApiUrl: "http://172.18.4.129/iARWebAPI",
  ApiUrl: "http://172.18.4.129/iARWebAPI",
  linkUsed: '172.18.4.129'
};
///gebbs 192.168.30.28:1001 - webapp, 192.168.30.28:1007 , db username and pass : - iARProject
